import { debugManager } from '@tunein/web-utils';
const verboseEventsMap = {
    adprogress: true,
    progress: true,
    timeupdate: true,
};
const _debug = debugManager.createDebugger('MP', 'Web Media Player');
export function setDebugMode(debugLevel) {
    if (typeof debugLevel === 'undefined') {
        return;
    }
    console.log('_debug.isActive()', _debug.isActive());
    if (!_debug.isActive()) {
        _debug.toggle({ verbose: debugLevel === 'verbose' });
    }
}
export function debug(message, ...args) {
    if (verboseEventsMap[message]) {
        return _debug.verbose(message, ...args);
    }
    _debug(message, ...args);
}
